"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var odc_flex_1 = __importDefault(require("@tencent/odc-flex"));
var spaui_1 = require("@tencent/spaui");
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var SlickComponent = function SlickComponent(props) {
  var _a;
  var _b = props.slidesToShow,
    slidesToShow = _b === void 0 ? 1 : _b,
    _c = props.slidesToScroll,
    slidesToScroll = _c === void 0 ? 1 : _c,
    prevArrow = props.prevArrow,
    nextArrow = props.nextArrow,
    prevArrowClassName = props.prevArrowClassName,
    nextArrowClassName = props.nextArrowClassName,
    prevArrowProps = props.prevArrowProps,
    nextArrowProps = props.nextArrowProps,
    arrowProps = props.arrowProps,
    children = props.children,
    _d = props.showEndPointArrows,
    showEndPointArrows = _d === void 0 ? false : _d,
    _e = props.theme,
    theme = _e === void 0 ? 'normal' : _e,
    gap = props.gap,
    trackClassName = props.trackClassName,
    listClassName = props.listClassName,
    _f = props.slickGap,
    slickGap = _f === void 0 ? 8 : _f,
    _g = props.page,
    page = _g === void 0 ? -1 : _g,
    _h = props.onPageChange,
    onPageChange = _h === void 0 ? null : _h;
  var _j = __read((0, react_1.useState)(0), 2),
    currentIndex = _j[0],
    setCurrentIndex = _j[1];
  var _k = __read((0, react_1.useState)(0), 2),
    listW = _k[0],
    setListW = _k[1];
  var listRef = react_1["default"].useRef(null);
  var index = page > -1 ? page : currentIndex;
  var handleIndexChange = onPageChange ? onPageChange : setCurrentIndex;
  (0, react_1.useLayoutEffect)(function () {
    if (listRef.current) {
      var el = listRef.current;
      var resizeObserver_1 = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          setListW(entry.target.clientWidth);
        });
      });
      resizeObserver_1.observe(el);
      return function () {
        resizeObserver_1.disconnect();
      };
    }
  }, []);
  /**
   * 间距
   */
  var numGap = gap ? Number(gap) : 0;
  /**
   * List 宽度
   */
  var listWidth = listW;
  /**
   * 单个 Slide 宽度
   */
  var slideWidth = listWidth / slidesToShow - (slidesToShow - 1) * numGap / slidesToShow;
  /**
   * Slide 总数量
   */
  var count = react_1["default"].Children.count(children);
  /**
   * 偏移量
   */
  var translateX = -1 * index * slidesToScroll * (slideWidth + numGap);
  /**
   * 是否显示左侧的按钮
   */
  var showPrevButton = showEndPointArrows || index > 0;
  /**
   * 是否显示右侧的按钮
   */
  var showNextButton = showEndPointArrows || index * slidesToScroll < count - slidesToShow;
  var handlePrev = function handlePrev() {
    showPrevButton && handleIndexChange(index - 1);
  };
  var handleNext = function handleNext() {
    showNextButton && handleIndexChange(index + 1);
  };
  var childrenList = react_1["default"].Children.toArray(children);
  childrenList = childrenList.filter(function (child) {
    if (typeof child === 'string') {
      return !!child.trim();
    }
    return !!child;
  });
  var renderPrevArrow = function renderPrevArrow() {
    var prevButtonProps = __assign(__assign({
      className: (0, classnames_1["default"])('odc-slick-arrow-btn slick-prev', prevArrowClassName),
      onClick: handlePrev
    }, prevArrowProps), arrowProps);
    if (prevArrow) {
      return react_1["default"].cloneElement(prevArrow, __assign({}, prevButtonProps));
    }
    return react_1["default"].createElement(spaui_1.Button, __assign({}, prevButtonProps), react_1["default"].createElement(spaui_1.Icon, {
      name: "left-arrow-outlined"
    }));
  };
  var renderNextArrow = function renderNextArrow() {
    var nextButtonProps = __assign(__assign({
      className: (0, classnames_1["default"])('odc-slick-arrow-btn slick-next', nextArrowClassName),
      onClick: handleNext
    }, nextArrowProps), arrowProps);
    if (nextArrow) {
      return react_1["default"].cloneElement(nextArrow, __assign({}, nextButtonProps));
    }
    return react_1["default"].createElement(spaui_1.Button, __assign({}, nextButtonProps), react_1["default"].createElement(spaui_1.Icon, {
      name: "right-arrow-outlined"
    }));
  };
  return react_1["default"].createElement(odc_flex_1["default"], __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-slick', (_a = {},
    // 'multiple-items': true || slidesToShow > 1,
    _a["theme-".concat(theme)] = theme, _a["gap-".concat(slickGap)] = slickGap, _a)),
    supportAllEvents: true
  }, SlickComponent)), showPrevButton && renderPrevArrow(), react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])('odc-slick-list', listClassName),
    ref: listRef
  }, react_1["default"].createElement(odc_flex_1["default"], {
    className: (0, classnames_1["default"])('odc-slick-track', trackClassName),
    gap: gap,
    style: {
      transform: "translateX(".concat((translateX / 1).toFixed(4), "px)")
    }
  }, childrenList.map(function (child, index) {
    return react_1["default"].createElement(odc_frame_1["default"], {
      className: "odc-slick-slide flex-none",
      style: {
        width: "".concat((slideWidth / 1).toFixed(4), "px")
      },
      key: index.toString(),
      "data-index": index
    }, child);
  }))), showNextButton && renderNextArrow());
};
(0, spaui_utils_1.setComponentMark)(SlickComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(SlickComponent);